import { useContext, createElement } from 'react';
import { NavbarContext } from '../NavbarContextProvider';
import { styled, View, fromTheme, webOnlyStyles } from 'lib_ui-primitives';
import propTypes from 'prop-types';

const rc = createElement;

let LockedContainer = styled(View).attrs({ name: 'locked-main-container' })`
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;
    margin-left: ${fromTheme('mainContainer', 'margin')};
    display: inherit;
    position: absolute;
    left: ${({ theme }) => theme.drawerWidth - theme.mainContainer.offset + 'px'};
    top: ${fromTheme('titleBar', 'height')};
    width: ${({ theme }) => theme.width - theme.drawerWidth + 'px'};
`;
LockedContainer = webOnlyStyles(LockedContainer)`
    height: Calc(100% - ${fromTheme('titleBar', 'height')});
`;

let UnlockedContainer = styled(View).attrs({ name: 'unlocked-main-container' })`
    margin-left: ${fromTheme('mainContainer', 'margin')};
    max-width: ${fromTheme('width')};
    flex-grow: 1;
`;
UnlockedContainer = webOnlyStyles(UnlockedContainer)`
    height: Calc(100% - ${fromTheme('titleBar', 'height')});
`;

function MainContainer(props) {
    const { locked, ready } = useContext(NavbarContext);
    if (!ready) return null;
    if (!props.excludeSideBar && locked) return rc(LockedContainer, null, props.children);
    return rc(UnlockedContainer, null, props.children);
}
MainContainer.propTypes = {
    children: propTypes.node,
    excludeSideBar: propTypes.bool
};
export default MainContainer;
